import React from 'react';
import WinBase from '../components/base/win-base';

const TourneysComponentsFormRulesPartWin = () => {
  return <WinBase sportType="general" />;
};

export default TourneysComponentsFormRulesPartWin;
